import type { GroupDto, Role } from '../../api/types';

type Maybe<T> = T | null | undefined;

export function canEditGroup(params: {
  role: Maybe<Role>;
  group: Maybe<GroupDto>;
  currentUserTelegramId: Maybe<string>;
}): boolean {
  const { role, group, currentUserTelegramId } = params;
  if (!role) return false;
  if (!group) return false;

  if (role === 'admin') return true;
  const isOwner = currentUserTelegramId != null && group.createdByTelegramId === currentUserTelegramId;
  return isOwner;
}
